import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {plainToInstance} from 'class-transformer';
import {getHttpParams} from '../helpers/request.helper';
import {RenewalLog, RenewalLogDetailedReportParams} from '../models/api/renewal-log.model';

@Injectable()
export class RenewalLogService {
    baseUrl = '/evo/api/renewalLog';

    constructor(private http: HttpClient) {}

    getReportFromCache() {
        return this.http
            .get<RenewalLog>(`${this.baseUrl}/reportFromCache`)
            .pipe(map((response) => plainToInstance(RenewalLog, response)));
    }

    getDetailedReport(reportParams: RenewalLogDetailedReportParams) {
        const params = getHttpParams(reportParams);
        return this.http.get(`${this.baseUrl}/detailedReport`, {params});
    }
}
